import { combineReducers } from 'redux'
import misc from './misc'
import log from './log'

export default combineReducers({
  misc,
  log,
})
